export default {
  companyAdaptationMetadata: {
    titles: {
      adaptationPlans: 'Планы адаптации',
      assignAdaptation: 'Назначение планов адаптации',
      exportAdaptation: 'Выгрузить в excel результаты адаптации',
      settings: 'Управление планами адаптации',
      createPlan: 'Новый план',
      editPlan: 'Редактировать название адаптации',
      copyPlan: 'Копирование в другую компанию',
      createTask: 'Новая задача',
      editTask: 'Редактировать задачу',
      selectEmployees: 'Выбор сотрудников',
      selectMentors: 'Выбор наставников',
      changeDeadline: 'Изменить дедлайн для назначенной адаптации',
    },
    descriptions: {
      adaptationPlans:
        'Для начала работы с планом адаптации, сотрудникам необходимо подключить HR-Buddy_bot. Сделать это можно на платформе или перейдя по ссылке из письма, которое получат пользователи при назначении плана адаптации.',
      editPlan: 'Название плана адаптации будет изменено и у планов уже назначенных на сотрудников',
      copyPlan: 'Выберите компанию или несколько, куда хотите скопировать план адаптации',
    },
    buttons: {
      assignPlan: 'Назначить план',
      createPlan: 'Создать план',
      deletePlan: 'Удалить план',
      createTask: 'Добавить задачу',
      moveUp: 'Переместить вверх',
      moveDown: 'Переместить вниз',
      managingPlans: 'Управление планами',
      addPlan: 'Добавить назначение',
      removePlan: 'Удалить назначение',
    },
    tooltips: {
      refresh: 'Обновить список',
      day: 'Укажите номер дня, в который сотрудник должен получить данную задачу. Номер дня с даты назначения плана на сотрудника. Например, если вы хотите, чтобы сотрудник получил задачу на 3 день после назначения ему плана, поставьте цифру 3. Выходные дни (сб и вс) пропускаются.',
      image:
        'Вы можете приложить одно изображение к задаче, оно отобразится перед описанием задачи. Ограничение веса изображения: не более 5 Mb.',
      file: 'Вы можете приложить один файл к задаче. Ограничение веса файла: не более 5 Mb.',
    },
    placeholders: {
      selectPlan: 'Выберите план',
      enterUserName: 'Введите ФИО',
    },
    assignMenu: {
      internal: 'на сотрудника компании',
      external: 'на внешнего пользователя',
    },
    menuSettings: {
      editPlan: 'Редактировать название',
      copyPlan: 'Скопировать план адаптации',
      copyPlanTo: 'Скопировать в другую компанию',
    },
    statuses: {
      all: 'Все',
      completed: 'Завершённые',
      notCompleted: 'Незавершённые',
    },
    tableHeaders: {
      planName: 'План',
      dateStart: 'Дата старта',
      dateFrom: 'с',
      dateTo: 'по',
      participant: 'Участник',
      mentor: 'Наставник',
      team: 'Команда',
      deadline: 'Дедлайн',
      progress: 'Прогресс',
      statistics: 'Статистика',
    },
    stubs: {
      noPlans: 'Вы пока не добавили ни одного плана',
      noTasks: 'Вы пока не добавили ни одной задачи',
      noEmployees:
        'Для назначения плана добавьте сотрудников в компанию. Для этого перейдите на вкладку',
      noAssignedPlans:
        'Вы пока не назначили ни одного плана, создайте новый план в разделе «Управление планами»',
    },
    // messages
    successMessages: {
      createPlan: 'План успешно создан',
      editPlan: 'План успешно изменён',
      copyPlan: 'План успешно скопирован',
      deletePlan: 'План успешно удалён',
      createTask: 'Задача успешно создана',
      editTask: 'Задача успешно изменена',
      swapTasks: 'Задачи успешно перемещены',
      deleteTask: 'Задача успешно удалена',
      removeDeadline: 'Дедлайн успешно удален',
      setDeadline: 'Дедлайн успешно установлен',
      assignAdaptation: 'Планы адаптации успешно назначены',
      partialAssignAdaptation:
        'Планы назначены доступным пользователям. Не назначено из-за ограничения количества сотрудников: {count}',
      deleteAdaptations: 'Выбранные планы адаптации успешно удалены',
    },
    errorMessages: {
      createPlan: 'Не удалось создать план',
      editPlan: 'Не удалось изменить план',
      copyPlan: 'Не удалось скопировать план',
      exportPlan: 'Не удалось выгрузить план',
      deletePlan: 'Не удалось удалить план',
      createTask: 'Не удалось создать задачу',
      editTask: 'Не удалось изменить задачу',
      swapTasks: 'Не удалось переместить задачи',
      deleteTask: 'Не удалось удалить задачу',
      removeDeadline: 'Не удалось удалить дедлайн',
      setDeadline: 'Не удалось установить дедлайн',
      assignAdaptation: 'Не удалось назначить планы адаптации',
      deleteAdaptations: 'Не удалось удалить выбранные планы адаптации',
      exportAdaptation: {
        default: 'Не удалось сформировать файл',
        timeoutExpired:
          'Слишком большой объём данных. Пожалуйста, сократите период и повторите ещё раз.',
      },
    },
    // confirm dialogs
    confirmDeleteAdaptations: {
      title: 'Действительно удалить план адаптации?',
      text: 'Удалённые планы адаптации нельзя восстановить. Вы уверены?',
    },
    confirmDeleteTask: {
      title: 'Удалить задачу?',
      text: 'Задача будет удалена из плана',
    },
    confirmDeletePlan: {
      title: 'Удалить план?',
      text: 'Это удалит текущий план адаптации, все его задачи и все назначенные адаптации по этому плану.',
    },
  },
};
